import { Badge } from '@/components/ui/badge'
import { MetadataForm } from '@/components/common/MetadataForm'

import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

interface ProfileStepSectionProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function ProfileStepSection({ workflow }: ProfileStepSectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h4 className="text-sm font-semibold">Mission Profile</h4>
          <p className="text-xs text-muted-foreground">
            Capture system details, stakeholders, and engagement window.
          </p>
        </div>
        {workflow.selectedMissionId && (
          <Badge variant="outline">
            {workflow.missionProfileLoading
              ? 'Loading...'
              : workflow.missionProfile
              ? 'Profile Loaded'
              : 'Not Started'}
          </Badge>
        )}
      </div>
      {workflow.selectedMissionId ? (
        <>
          <MetadataForm
            schemaId="softwareiq-mission-profile"
            initialData={workflow.profileDefaults}
            onSubmit={workflow.handleProfileSubmit}
            submitLabel="Save Mission Profile"
            isSubmitting={workflow.profileMutationPending}
            inline
          />
          {workflow.profileStatus && <p className="text-xs text-muted-foreground">{workflow.profileStatus}</p>}
        </>
      ) : (
        <p className="text-sm text-muted-foreground">Select a mission to edit the profile.</p>
      )}
    </div>
  )
}
